var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icons } from 'src/ui/components/Icons/Icons';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import styles from './DropDownSection.module.scss';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { IDENTIFIER_DROPDOWN, IDENTIFIER_DROPDOWN_OPTIONS } from 'src/ui/components/DropDown/constants';
export var DropDownSection = function (props) {
    var _a;
    var label = props.label, children = props.children, className = props.className;
    var _b = useState(0), contentHeight = _b[0], setContentHeight = _b[1];
    var _c = useState(false), isOpen = _c[0], setIsOpen = _c[1];
    var contentRef = useRef(null);
    useEffect(function () {
        if (contentRef.current) {
            var height = contentRef.current.clientHeight;
            setContentHeight(height);
        }
    }, []);
    var handleOpen = function (e) {
        e.stopPropagation();
        setIsOpen(!isOpen);
    };
    var dropDownArrowClass = classNames(styles.dropDownArrowIcon, (_a = {},
        _a[styles.dropDownArrowForOpen] = isOpen,
        _a));
    var dynamicHeight = isOpen ? contentHeight : 0;
    return (_jsxs("div", __assign({ "data-test": IDENTIFIER_DROPDOWN, className: classNames(styles.dropDownWrapper, className) }, { children: [_jsxs("div", __assign({ className: styles.dropDownEmerged, onClick: handleOpen }, { children: [_jsx("span", __assign({ className: styles.dropDownEmergedLabel }, { children: label })), _jsx(Icons, { icon: E_ICONS.ARROW_RIGHT, className: dropDownArrowClass })] })), _jsx("div", __assign({ "data-test": IDENTIFIER_DROPDOWN_OPTIONS, className: styles.dropDownImmersed, style: { height: dynamicHeight } }, { children: _jsx("div", __assign({ ref: contentRef }, { children: children })) }))] })));
};
